import { Anchor } from '@zooplus/ui-components';
// eslint-disable-next-line import/no-unresolved
import { getUrlLocalised, useTranslation } from '../../../hooks/use-translations';
import React from 'react';

export type LinkProps = {
  href: string;
  textKey: string;
};

export const Link = (props: LinkProps) => {
  const { t } = useTranslation();
  return <Anchor href={getUrlLocalised(t, props.href)}>{t(`${props.textKey}`)}</Anchor>;
};
